/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Typography, Box, Grid } from '@mui/material';
import { BoxContainer } from '../Containers/BoxContainer';
import { ProjectCard } from './ProjectCard';

const dummyData = [
  {
    title: 'EPS Modernization',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.',
    hours: 165.78,
  },
  {
    title: 'EPS Modernization',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.',
    hours: 165.78,
  },
  {
    title: 'EPS Modernization',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.',
    hours: 165.78,
  },
  {
    title: 'EPS Modernization',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.',
    hours: 165.78,
  },
];

export const ProjectBox = (props) => {
  return (
    <BoxContainer bg={{ bgcolor: 'rgb(26, 32, 44, 0.85)' }}>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          m: 3,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            textTransform: 'uppercase',
            fontWeight: 600,
            pb: 3,
            textAlign: 'center',
          }}
        >
          Projects
        </Typography>
        <Grid container spacing={2} sx={{ px: 2, mb: 2 }}>
          {dummyData.map((data, index) => (
            <ProjectCard
              key={index}
              title={data.title}
              desc={data.desc}
              hours={data.hours}
            />
          ))}
        </Grid>
      </Box>
    </BoxContainer>
  );
};
